export default __webpack_public_path__ + "static/media/warning.7001c032.svg";